export const paymentBankLookUp = `<p>Lloyds Bank Gem Connect offers the functionality to look up a Bank BIC code and address details. The information displayed is the same as when you are making an international payment. You navigate to the bank lookup on the top right of the screen.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/5/1.png' /></p>
<br/>
<div class='row'>
<div class='col-6'>
<p><img src='${process.env.PUBLIC_URL}/images/4/5/2.png' /></p>
</div>
<div class='col-6'>
<p>When this screen displays, you must enter the Bank name and Country and press ‘Search’ to return the search results.</p>
</div>
</div>
<div class='row'>
<div class='col-8'>
<p><img src='${process.env.PUBLIC_URL}/images/4/5/3.png' /></p>
</div>
<div class='col-4'>
<p>The search results are displayed in a table. If multiple banks are displayed, you can either tab through the pages or scroll up and down to find the bank you are looking for.</p>
</div>
</div>

<div class='row'>
<div class='col-8'>
<p><img src='${process.env.PUBLIC_URL}/images/4/5/4.png' /></p>
</div>
<div class='col-4'>
<p>If you click on the Bank Name, a display of the bank details is presented to you.&nbsp;</p>
</div>
</div>`;


// WEBPACK FOOTER //
// ./src/components/content/payments/5-bankLookUp.ts